/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoAdvancedSearchModal implements angular.IDirective {
        restrict = "E";
        transclude: { [slot: string]: string };
        scope = {
            headerTitle: "@?",
            headerClass: "@?",
            className: "@?",
            modalSave: "&?",
            modalCancel: "&?",
            modalClear: "&?",
            hasCustomFooter: "<?", // If you use custom footer, this property must be set to true
            bodyClass: "@?",
            bodyStyle: "=?"
        };

        templateUrl = 'app/components/controls/layout/advancedSearchModalTemplate.html';

        constructor() {
            this.transclude = {
                'modalBody': 'modalBody',
                'modalFooter': '?modalFooter'
            };
        }

        link = (scope: any) => {

            /* Unless custom title and class is passed in,
            the modal will use the Advanced Search header title & styling */
            if (_.isUndefined(scope.headerTitle)) {
                scope.headerTitle = 'LABEL_ADVANCED_SEARCH';
            }

            if (_.isUndefined(scope.headerClass)) {
                scope.headerClass = 'adv-search-modal__header--blue';
            }

            if (_.isUndefined(scope.bodyClass)) {
                scope.bodyClass = '';
            }

        }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoAdvancedSearchModal();
            }

            directive.$inject = [];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoAdvancedSearchModal", MeevoAdvancedSearchModal.factory());
}
